import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Star, Video, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function DoctorCard({ doctor }) {
  return (
    <div className="doccare-card p-5 hover-lift" data-testid={`doctor-card-${doctor.id}`}>
      <div className="flex items-start gap-4">
        <img
          src={doctor.photo}
          alt={doctor.name}
          className="w-16 h-16 rounded-2xl object-cover bg-slate-100"
        />
        <div className="min-w-0 flex-1">
          <h3 className="font-semibold text-slate-900 truncate">{doctor.name}</h3>
          <p className="text-sm text-emerald-700 font-medium">{doctor.specialty}</p>
          <p className="text-xs text-slate-500 mt-1 flex items-center gap-1">
            <MapPin className="w-3 h-3" /> {doctor.location}
          </p>
        </div>
      </div>
      <div className="mt-4 flex items-center gap-2 flex-wrap">
        <Badge variant="secondary" className="rounded-full text-[11px]">
          {doctor.experience_years}+ yrs
        </Badge>
        {doctor.consultation_types?.includes("video") && (
          <Badge className="rounded-full text-[11px] bg-blue-50 text-blue-700 hover:bg-blue-50">
            <Video className="w-3 h-3 mr-1" /> Video
          </Badge>
        )}
        {doctor.consultation_types?.includes("in_person") && (
          <Badge className="rounded-full text-[11px] bg-emerald-50 text-emerald-700 hover:bg-emerald-50">
            <Building2 className="w-3 h-3 mr-1" /> In-person
          </Badge>
        )}
      </div>
      <div className="mt-4 flex items-center justify-between">
        <div>
          <p className="text-xs text-slate-500">Consultation</p>
          <p className="text-sm font-semibold text-slate-900">${doctor.fee}</p>
        </div>
        <Link to={`/doctors/${doctor.id}`}>
          <Button size="sm" className="rounded-full" data-testid={`view-doctor-${doctor.id}`}>
            View profile
          </Button>
        </Link>
      </div>
    </div>
  );
}
